<template>
  <DesktopView v-if="isDesktop" v-bind="$attrs">
    <template #header>
      <Header
        @headerclick="reset"
        @switchlanguage="reset"
        ref="headerContent" />
    </template>    
  </DesktopView>
  <IphoneView v-else v-bind="$attrs"></IphoneView>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from "vue";
import DesktopView from "@/containers/desktopview.vue";
import IphoneView from "@/containers/iphoneview.vue";
import Header from '@/components/header.vue';
import { useMenuStore } from "@/stores/menu.ts";
import { useEventSearch } from "@/stores/eventSearch.ts";

export default {
  components: {
    DesktopView,
    IphoneView,
    Header
  },
  props: ["isDesktop"],
  inheritAttrs: false,
  setup(props){
    const menuStore = useMenuStore();
    const eventsearch = useEventSearch();
    const reset = () => {
      menuStore.selectMenuItem(null);
      eventsearch.updateCurrentFilters(null);
      eventsearch.updateSearchFilter(null);
    }

    return {
      reset
    }
  }
};
</script>
